import {createSSRApp} from "vue";
import App from "./App.vue";
import stores from "@/stores";
import * as Sentry from "@sentry/vue";
import "@/static/vendor/iconfont/iconfont.css"
import "@/static/css/main.scss"

export function createApp() {
    const app = createSSRApp(App);

    // if (import.meta.env.VITE_ENABLE_SENTRY === 'true') {
    //     Sentry.init({
    //         app,
    //         dsn: import.meta.env.VITE_SENTRY_DSN,
    //         integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    //         // Tracing
    //         tracesSampleRate: 1.0, //  Capture 100% of the transactions
    //         // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    //         tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    //         // Session Replay
    //         replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    //         replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    //         // transportOptions: {
    //         //     tunnel: 'https://apm.tianzhi.xyz/tunnel',
    //         // },
    //         environment: import.meta.env.MODE,
    //         release: __APP_INFO__.fullVersion,
    //     })
    // }

    app.config.errorHandler = (err, instance, info) => {
        // 向追踪服务报告错误
        if (import.meta.env.VITE_ENABLE_SENTRY === 'true') {
            Sentry.captureException(err, {
                contexts: {vue: {component: instance, info}},
            })
        }
    }

    app.use(stores)
    return {
        app,
        stores, // 此处必须将 Pinia 返回
    };
}
